<div class="app-schedules-timeline">

    <kendo-scheduler [kendoSchedulerBinding]="eventsDetails" [selectedDate]="selectedDate" [eventClass]="getEventColor"
        [group]="group" [resources]="resources" (slotSelectionChange)="onSelectionChange($event)"
        (slotClick)="onSlotClick($event)" (dateChange)="onDateChange($event)" class="scheduler-wrapper"
        kendoSchedulerSlotSelectable [selectable]="false">

        <ng-template kendoSchedulerGroupHeaderTemplate let-resource="resource">
            <div class="k-d-flex k-align-items-start k-gap-x-md">
                <!-- <button kendoButton [svgIcon]="xMark" themeColor="light" (click)="onRemoveResource(resource)"
                    *ngIf="resource?.rowType !== 'Provider' && resource?.rowType !== 'Evaluator'"></button> -->
                <div>
                    <ng-container *ngIf="(resource?.rowType === 'Provider' || 
                        resource?.rowType === 'Evaluator'); else studentTemplate">
                        <strong>{{resource?.resourceName}} (You)</strong>
                    </ng-container>
                    <ng-template #studentTemplate>
                        <strong>{{resource?.resourceName}} (ID: {{resource?.nycId}})</strong>
                        <p class="!k-my-0">
                            <span class="secondary">DOB: {{resource?.dob | date: 'MM/dd/yyyy'}}

                            </span>
                            <span class="secondary" *ngIf="resource?.grade"> |
                                Grade:
                                {{resource?.grade}}</span>
                        </p>
                        <p class="!k-my-0" *ngIf="resource?.Disability">
                            <span class="secondary"> | Disability: {{resource?.disability}}</span>
                        </p>
                    </ng-template>
                </div>
            </div>
        </ng-template>
        <ng-template kendoSchedulerEventTemplate let-event="event">

            <!-- Slot-created event -->
            <!-- <ng-container *ngIf="event?.dataItem?.show; else existingEvent">
                <p>sssss</p>
                <div [ngClass]="getEvalutaorEventColor(event)">
                    <strong class="k-font-semibold">
                        {{ event.dataItem.scheduleText }}
                    </strong>
                </div>
            </ng-container> -->

            <!-- <ng-container *ngIf="event?.dataItem?.show"  [style.top.px]="inlineTop" [style.left.px]="inlineLeft">
                <div class="inline-popup" [ngClass]="getEvalutaorEventColor(event.dataItem)">
                    <div class="popup-inner">
                        <span class="plus">+</span>
                        Schedule
                        {{ event.start | date:'MMM dd, h:mma' }}
                        –
                        {{ event.end | date:'h:mma' }}
                    </div>
                </div>
            </ng-container> -->
            <!-- [ngClass]="getEvalutaorEventColor(event.dataItem)" -->
            <div *ngIf=" event?.dataItem?.resourceType === 'Evaluator' && studentsSelected">
                <strong class="k-font-semibold">[EN] {{ event?.dataItem?.title }}</strong>
                <p class="!k-m-0">
                    <small>
                        [{{event?.dataItem?.location}}] -
                        {{event?.dataItem?.studentName}}
                    </small>
                </p>
            </div>
            <!-- [ngClass]="getEventColor(event.dataItem)" -->
            <div *ngIf="event?.dataItem?.resourceType === 'Student'">
                <div>
                    <strong class="k-font-semibold">{{event?.dataItem?.dataItem?.courseName}}</strong>

                    <p class="!k-m-0">
                        {{
                        event?.dataItem?.dataItem?.courseCode }}
                    </p>
                    <p class="!k-m-0 k-pt-4">
                        {{
                        event?.dataItem?.dataItem?.teacherName }} - {{
                        event?.dataItem?.dataItem?.dbn }}
                    </p>
                    <br>
                </div>
            </div>


            <!-- <ng-container *ngIf="event?.dataItem?.resourceType === 'Student' && !studentsSelected">
                <div class="event-card">
                    <div class="event-title">
                        {{ event?.dataItem?.dataItem?.courseName }}
                    </div>

                    <div class="event-sub">
                        {{ event?.dataItem?.dataItem?.courseCode }}
                    </div>

                    <div class="event-meta">
                        {{ event?.dataItem?.dataItem?.teacherName }}- {{
                        event?.dataItem?.dataItem?.DBN }}
                    </div>
                </div>
            </ng-container> -->

            <!-- removed debug interpolation that invoked getEvent() on every change detection -->
            <!-- [ngClass]="getEventColor(event.dataItem)" -->
            <div
                *ngIf="event?.dataItem?.resourceType === 'Provider'&& event?.dataItem?.sessionType === 1  && !studentsSelected">
                <strong class="k-font-semibold">[{{ event?.dataItem?.language }}]
                    {{event?.dataItem?.dataItem?.sessionLabel
                    }} -
                    {{event?.dataItem?.studentMandates?.length}}/{{getGroupSize(event?.dataItem?.groupSize)}}</strong>

                <!-- {{event?.dataItem?.serviceType}} -
                    {{event?.dataItem?.studentMandates?.length}}/{{getGroupSize(event?.dataItem?.groupSize)}} -->

                <p class="!k-m-0"><small>{{ event?.dataItem?.location }}</small></p>
            </div>

            <div
                *ngIf=" event?.dataItem?.resourceType === 'Provider' && event?.dataItem?.sessionType !== 1 && !studentsSelected ">
                <strong class="k-font-semibold">{{event?.dataItem?.sessionTypeName}}</strong>
                <p class="!k-m-0" *ngIf="getLocationBySessionType(event?.dataItem?.sessionType)"><small>{{
                        event?.dataItem?.location }}</small></p>
            </div>
            <!-- <div *ngIf="!studentsSelected">

                <strong class="k-font-semibold">[{{ event?.dataItem?.language }}]
                    {{event?.dataItem?.serviceType}} -
                    {{event?.dataItem?.studentMandates?.length}}/{{getGroupSize(event?.dataItem?.groupSize)}}</strong>
                <p class="!k-m-0"><small>{{ event?.dataItem?.location }}</small></p>
            </div>
            <div *ngIf="!studentsSelected">
                <strong class="k-font-semibold">{{event?.dataItem?.sessionTypeName}}</strong>
                <p class="!k-m-0" *ngIf="getLocationBySessionType(event?.dataItem?.sessionType)"><small>{{
                        event?.dataItem?.location }}</small></p>
            </div>
            <div *ngIf="!studentsSelected">
                <strong class="k-font-semibold">[EN] {{event?.title}}</strong>
                <p class="!k-m-0"><small>[{{event?.dataItem?.location}}] - {{
                        event?.dataItem?.studentName }}</small></p>
            </div> -->
        </ng-template>

        <kendo-scheduler-timeline-view [startTime]="startTime" [endTime]="endTime"
            [eventHeight]="100"></kendo-scheduler-timeline-view>

    </kendo-scheduler>

    <div *ngIf="checkStatus && studentsSelected" class="inline-schedule-button" [style.top.px]="inlineTop"
        (click)="openScheduler()" [style.left.px]="inlineLeft" role="button" tabindex="0"
        (keydown.enter)="openScheduler()" (keydown.space)="openScheduler()" aria-label="Schedule session">
        <span class="plus color">+</span>
        Schedule
        {{ selectedSlotStart | date:'MMM dd, h:mma' }}
        –
        {{ selectedSlotEnd | date:'h:mma' }}
    </div>


</div>